import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Config } from 'src/app/config';
import { AccessRightManagement } from 'src/app/helpers/access-rights';
import { ServerConfig } from 'src/app/models/ServerConfig';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {


  constructor(
    private router: Router,
    private accessChecker: AccessRightManagement,
    private config: Config
  ) { 
    
  }

  //users who must set up 2fa are sent to the setup page before the dashboard module is downloaded
  canLoad(route: Route) {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.requiresTwoFactorSetup) {
      this.router.navigate(['/authentication/setup-2fa']);
      return false;
    }

    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //users who must set up 2fa are restricted to the setup page until setup is complete
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.requiresTwoFactorSetup) {
      this.router.navigate(['/authentication/setup-2fa']);
      return false;
    }

    return true;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('currentUser')) {
      //logged in

      if (!this.accessChecker.hasRight("RunReports")) {
        //no access

        if (this.accessChecker.hasRight("permissions.efficiencyaudit.access")) {
          //user can access audit, so redirect
          this.config.getServerConfig().then(cfg => {
            window.location.href = cfg.efficiencyAuditSiteUrl;
          });
          return false;
        }

        //handle lower
        return true;
        
      }

      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/authentication/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
